"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);

var _browserTransport = require('shared/services/directUpload/browserTransport');
var _uploadFileWithFallback = require('shared/services/directUpload/uploadFileWithFallback');

// Uploads a file that isn't a chat attachment (CSV imports) straight to GCS,
// or through /upload_file when the server doesn't take direct uploads. A
// missing or empty file still goes to /upload_file, as before.
 const uploadStandaloneFile = (file) => file && file.size > 0
  ? _uploadFileWithFallback.uploadFileDirect.call(void 0, _client2.default, file, { transport: _browserTransport.createBrowserTransport.call(void 0, file) })
  : _client2.default.uploadFile(file ); exports.uploadStandaloneFile = uploadStandaloneFile
